import React from "react";
import { ArrowUp } from "lucide-react";
import { Portfolio } from "../providers/PortfolioContext";
import { useCursor } from "../providers/CursorContext";

interface ItemPortfolioProps {
  portfolio: Portfolio;
  index: number;
  onTap: () => void;
}

export const ItemPortfolio: React.FC<ItemPortfolioProps> = ({
  portfolio,
  index,
  onTap,
}) => {
  const { setCursorSize, setHover } = useCursor();

  // Flutter staggered logic: even cards are tall (1.4 ratio), odd cards are square (1.0 ratio)
  const isTall = index % 2 === 0;
  const aspectRatioClass = isTall ? "aspect-[3/4.2]" : "aspect-square";

  return (
    <div
      onClick={onTap}
      onMouseEnter={() => {
        setHover(true);
        setCursorSize(48);
      }}
      onMouseLeave={() => {
        setHover(false);
        setCursorSize(24);
      }}
      className={`group relative overflow-hidden rounded-[18px] bg-bg border border-stroke cursor-pointer transition-all duration-300 hover:scale-[0.98] active:scale-95 ${aspectRatioClass} w-full`}
    >
      {/* Background Image */}
      <img
        src={portfolio.image}
        alt={portfolio.title}
        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
      />

      {/* Hover Overlay Panel */}
      <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-between p-6">
        {/* Rotating Arrow Indicator */}
        <div className="flex-1 flex items-center justify-center">
          <ArrowUp
            className="text-white w-20 h-20 md:w-28 md:h-28 stroke-[1.25] transition-transform duration-300 transform -rotate-45 group-hover:rotate-0"
          />
        </div>

        {/* Sliding Labels */}
        <div className="flex flex-col gap-1 text-left transform translate-y-6 group-hover:translate-y-0 transition-transform duration-300 select-text">
          <h3 className="font-rubik font-bold text-white text-lg md:text-xl">
            {portfolio.title}
          </h3>
          <p className="font-nunito text-sm md:text-base text-white/80">
            {portfolio.platform}
          </p>
        </div>
      </div>
    </div>
  );
};
